export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
  
    // Get the day of the month
    const day = date.getDate();
  
    // Add ordinal suffix (st, nd, rd, th)
    const getOrdinalSuffix = (day: number): string => {
      if (day > 3 && day < 21) return 'th'; // Covers 11th to 19th
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
  
    // Get the month name
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = monthNames[date.getMonth()];
  
    // Get the year
    const year = date.getFullYear();
  
    // Return the formatted date
    return `${dayWithSuffix} ${month} ${year}`;
  };

export const getValidLocalDate = (dateString: string): string | 'Invalid Date' => {
  const regex = /^(\d{1,2})[-\/](\d{1,2})[-\/](\d{2}|\d{4})$/;
  const match = dateString.match(regex);
  if (!match) return 'Invalid Date';
  let day = Number(match[1]);
  let month = Number(match[2]);
  let year = Number(match[3]);
  // Convert 2-digit year to 4-digit
  if (year < 100) {
    year += year < 50 ? 2000 : 1900;
  }
  // Validate range
  if (day < 1 || day > 31 || month < 1 || month > 12) return 'Invalid Date';
  // Use Date.UTC to avoid timezone shift
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  // Final validation to catch things like Feb 30
  if (
    utcDate.getUTCFullYear() !== year ||
    utcDate.getUTCMonth() !== month - 1 ||
    utcDate.getUTCDate() !== day
  ) {
    return 'Invalid Date';
  }
  // Format result back to DD-MM-YYYY
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(day)}-${pad(month)}-${year}`;
};

  export const convertDateFormat = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export function isValidDDMMYYYY(dateStr: string): boolean {
  if (!/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return false;
  const [dd, mm, yyyy] = dateStr.split('-').map(str=>str.trim()).map(Number);

  // Check valid month
  if (Number(mm) < 1 || Number(mm) > 12) return false;

  // Days in each month
  const daysInMonth = [31, (isLeapYear(yyyy) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Check valid day for the month
  if (dd < 1 || dd > daysInMonth[mm - 1]) return false;

  return true;
}

export function isTodayOrPastDate(dateStr: string): boolean {
  const [day, month, year] = dateStr.split('-').map(Number);
  if (!day || !month || !year) return false;
  const inputDate = new Date(year, month - 1, day);
  const today = new Date();
  // Set time to 00:00:00 for accurate comparison
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  return inputDate <= today;
}

// Helper function for leap year
function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}